module.exports = __webpack_public_path__ + "img/Light.189768e5.png";